"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedRoute = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
exports.ProtectedRoute = react_1.default.memo(function (_a) {
    var component = _a.component, rest = __rest(_a, ["component"]);
    var RenderComponent = component;
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, __assign({}, rest, { render: function (_a) {
            var location = _a.location, match = _a.match;
            return (0, react_common_lib_1.isAuthenticated)() ? ((0, jsx_runtime_1.jsx)(RenderComponent, __assign({ match: match }, rest))) : ((0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: {
                    pathname: '/login',
                    state: { from: location },
                } }));
        } })));
});
exports.default = exports.ProtectedRoute;
